import { memo } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { MapUser } from '@atom/types/map';

import { getGoogleShapeCenter } from '../mapUtilities';

import { getUserSvg } from './markerIconUtilities';
import {
  MARKER_STYLE,
  resolveAnchor,
  resolveOpacity,
  resolveZIndex,
} from './markerUtilities';

type UserMarkerProps = {
  user: MapUser;
  isActive: boolean;
  disabled: boolean;
  onMarkerClick: (id: string, view: string) => void;
};

const UserMarker = ({
  user,
  isActive,
  disabled,
  onMarkerClick,
}: UserMarkerProps) => {
  const position = getGoogleShapeCenter(user.location);
  const svgUrl = getUserSvg(isActive);

  return (
    <AdvancedMarker
      position={position}
      zIndex={resolveZIndex('user', isActive)}
      {...resolveAnchor('user', isActive)}
      style={{ ...MARKER_STYLE, opacity: resolveOpacity(disabled) }}
      onClick={() => onMarkerClick(user.id, 'user')}
    >
      <img src={svgUrl} alt="" />
    </AdvancedMarker>
  );
};

export default memo(UserMarker);
